angular.module('ikeweb.unit').filter('dimensions', ['measurementFormatterService',
    function(measurementFormatterService) {

        function dimensions(value) {
            return (value || [])
                .map(measurementFormatterService.format)
                .join(' x ');
        }
        dimensions.$stateful = true;

        return dimensions;
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/unit/filters/dimensions.filter.js
// module id = 443
// module chunks = 0